import { useQuery } from "@tanstack/react-query";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { ServerStateKeys } from "../ServerStateKeys";
import { PayoutWeeklyTotalsResponseType } from "@sellar-io/api-v2/types";

export const usePayoutStats = <TData = PayoutWeeklyTotalsResponseType>() => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery<TData>({
    queryKey: [user?.uid, business?.id, ServerStateKeys.PayoutsStats],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "payout/totals",
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    placeholderData: (prev) => prev,
  });
};
